// extracted by mini-css-extract-plugin
module.exports = {"overlayNotification":"NotificationOverlay_overlayNotification__3YR09"};